import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { configuration } from '../configuration';
import { EKycProvider } from '../providers';

export default function BaseLayout() {
  useEffect(() => {
    // Only load Eruda when explicitly enabled via configuration
    const shouldLoadEruda = configuration.showConsole;

    if (shouldLoadEruda) {
      // Lazy load Eruda to avoid blocking initial render
      const loadEruda = async () => {
        try {
          const { default: eruda } = await import('eruda');
          eruda.init();
        } catch (error) {
          // eslint-disable-next-line no-console
          console.warn('Failed to load Eruda:', error);
        }
      };

      // Use requestIdleCallback for better performance when available
      if ('requestIdleCallback' in window) {
        requestIdleCallback(() => loadEruda());
      } else {
        // Fallback to setTimeout for browsers without requestIdleCallback
        setTimeout(loadEruda, 100);
      }
    }
  }, []);

  return (
    <EKycProvider>
      <Outlet />
    </EKycProvider>
  );
}
